import { render, staticRenderFns } from "./PriceInformationSummary.vue?vue&type=template&id=0b2d54fd&scoped=true"
import script from "./PriceInformationSummary.vue?vue&type=script&lang=js"
export * from "./PriceInformationSummary.vue?vue&type=script&lang=js"
import style0 from "./PriceInformationSummary.vue?vue&type=style&index=0&id=0b2d54fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d54fd",
  null
  
)

export default component.exports